import React, { ReactNode } from "react";
import ReactDOM from "react-dom";
import { FiX } from "react-icons/fi";
import { PrimaryButton } from "../PrimaryButton";
import { SecondaryButton } from "../SecondaryButton";
import { Checkbox } from "../Checkbox";

import {
  Backdrop,
  Container,
  Header,
  HeaderTop,
  Title,
  Subtitle,
  CloseBtn,
  Body,
  Footer,
  LeftFooter,
  RightFooter,
} from "./styles";

interface FormModalProps {
  open: boolean;
  onRequestClose: () => void;
  title: string;
  subtitle?: string;
  children: ReactNode;
  width?: string | number;
  
  // Footer Button Props
  onSave?: () => void;
  onCancel?: () => void;
  saveText?: string;
  cancelText?: string;
  isSaveLoading?: boolean;
  isSaveDisabled?: boolean;
  hideSaveButton?: boolean;
  
  // Optional extra feature for 'add another'
  showAddAnother?: boolean;
  addAnotherChecked?: boolean;
  onAddAnotherChange?: (checked: boolean) => void;
  
  // Custom left footer content
  customLeftFooter?: ReactNode;
}

export function FormModal({
  open,
  onRequestClose,
  title,
  subtitle,
  children,
  width = 640,
  onSave,
  onCancel,
  saveText = "Salvar",
  cancelText = "Cancelar",
  isSaveLoading = false,
  isSaveDisabled = false,
  hideSaveButton = false,
  showAddAnother = false,
  addAnotherChecked = false,
  onAddAnotherChange,
  customLeftFooter,
}: FormModalProps) {
  
  const handleCancel = () => {
    if (onCancel) onCancel();
    onRequestClose();
  };

  return ReactDOM.createPortal(
    <Backdrop open={open}>
      <Container modalWidth={width}>
        <Header>
          <HeaderTop>
            <Title>{title}</Title>
            <CloseBtn onClick={onRequestClose}>
              <FiX />
            </CloseBtn>
          </HeaderTop>
          {!!subtitle && <Subtitle>{subtitle}</Subtitle>}
        </Header>

        <Body>
          {children}
        </Body>

        <Footer>
          <LeftFooter>
            {customLeftFooter}
            {showAddAnother && onAddAnotherChange && (
              <label className="checkbox-wrapper">
                <Checkbox
                  checked={addAnotherChecked}
                  handleChange={(checked) => onAddAnotherChange(checked)}
                />
                Adicionar outro
              </label>
            )}
          </LeftFooter>

          <RightFooter>
            <SecondaryButton
              text={cancelText}
              onClick={handleCancel}
              disabled={isSaveLoading}
            />
            {!hideSaveButton && (
              <PrimaryButton
                text={saveText}
                onClick={onSave}
                loading={isSaveLoading}
                disabled={isSaveDisabled || isSaveLoading}
              />
            )}
          </RightFooter>
        </Footer>
      </Container>
    </Backdrop>,
    document.body
  );
}
